<template>
  <el-dialog
    title=""
    :visible.sync="isShowMap"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @closed="mapClosed"
    custom-class="map-location-dialog"
  >
    <h2 class="location-name">
      温馨提示！若自动获取的地点不对，可以通过地址或关键词搜索。
    </h2>

    <el-row :gutter="24">
      <el-col :span="15">
        <div class="search-group">
          <el-input v-model="keyword" placeholder="请输入地址" @keyup.enter.native="searchLocation"></el-input>
          <el-button class="search-btn-local" type="primary" @click="searchLocation">搜索</el-button>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="lng-lat-input">
            <span>坐标点 </span>
            <el-input v-model="map_lng_map_lat" disabled></el-input>
        </div>
      </el-col>
      
    </el-row>
    <div id="l-map" class="map-container"></div>
    <div class="floor-btn-info">
        <el-button type="primary" @click="confirm">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { loadBMap } from "@/utils/loadBMap.js";
export default {
  name: "MapLocation",
  props: {
    callback: Function, // 选中地区回调
  },
  data() {
    return {
      siteName:'',
      isShowMap: false,
      keyword: '',
      point_lng: '',
      point_lat: '',
      map:'',
      ak:'nRiAbKC245QLSOiFInQgqTU7',
      map_lng_map_lat:"",
    };
  },
  async mounted() {
    await loadBMap(this.ak) 
  },  
  methods: {
    openDialog (lng, lat,siteName) {
      this.siteName = siteName;
      this.isShowMap = true
      this.point_lng = lng || '';
      this.point_lat = lat || '';
      this.$nextTick(() => {
          this.init();
      })
    },
    init () {
      this.map = new BMapGL.Map("l-map");
      const vpoint = new BMapGL.Point(this.point_lng, this.point_lat);
      if(this.point_lng !== '' && this.point_lat !== '') {
          this.map_lng_map_lat = this.point_lng + ' ' +this.point_lat
          this.map.centerAndZoom(vpoint, 16);
          this.map.addOverlay(new BMapGL.Marker(vpoint));
          this.initMapOther();
      }else if(this.keyword !=''){
        this.searchLocation();
      }else {
        this.currentLocation();
      }
    },
    /** 初始化地图其他参数 */
    initMapOther () {
      const _this = this;
      this.map.enableScrollWheelZoom();//启用滚轮放大缩小
      this.map.addEventListener("click", e => {
        this.map.clearOverlays();//清除所有标注图层覆盖物
        var point = new BMapGL.Point(e.latlng.lng, e.latlng.lat);//初始化
        this.map.addOverlay(new BMapGL.Marker(point)); //添加图层覆盖物
        //将坐标显示到文本框
        this.point_lng = e.latlng.lng;
        this.point_lat = e.latlng.lat;
        this.map_lng_map_lat = e.latlng.lng + "   " + e.latlng.lat
      });
      //比例调节条
      this.map.enableScrollWheelZoom();
      const opts = {type: BMAP_NAVIGATION_CONTROL_LARGE}
      this.map.addControl(new BMapGL.NavigationControl(opts)); 
    },
    /** 当前定位 */
    currentLocation () {
      // 获取当前城市定位坐标
      const _this = this;
      const geoc = new BMapGL.Geolocation({maximumAge:10});
      geoc.getCurrentPosition(function (r) {
        if (this.getStatus() === BMAP_STATUS_SUCCESS) {
          const point = new BMapGL.Point(r.point.lng, r.point.lat);
          _this.map.centerAndZoom(point, 16);
          var mk = new BMapGL.Marker(point);
          _this.map.addOverlay(mk);
          _this.initMapOther()
        }
      })
    },
    /** 搜索定位 */
    searchLocation () {
      let _this=this;
      if (this.keyword.trim() === '') {
        this.currentLocation();
        return null;
      } 
      this.map.centerAndZoom(this.siteName, 14);
      const myGeo = new BMapGL.Geocoder()
      var options = {
        onSearchComplete: function(results){
          // 判断状态是否正确
          if (local.getStatus() == BMAP_STATUS_SUCCESS){
             _this.map.clearOverlays();//清除所有标注图层覆盖物
            let point=results._pois[0].point
            let pointA= new BMapGL.Point(point.lng, point.lat)
            _this.map.addOverlay(new BMapGL.Marker(point));
            _this.map.centerAndZoom(point, 16);

            _this.point_lng = point.lng;
            _this.point_lat = point.lat;
            _this.map_lng_map_lat = point.lng + "   " + point.lat
            _this.initMapOther()
            
          }
        }
      };
      var local = new BMapGL.LocalSearch(this.map, options);
      _this.keyword=_this.keyword
      local.search(_this.keyword);

    },
    /** 销毁地图 */
    mapClosed () {
      this.map = null
      this.keyword = ''
    },
    confirm(){
        this.callback && this.callback(this.point_lng, this.point_lat);
        this.isShowMap = false;
    }
  }
};
</script>
<style lang="less">
.map-location-dialog {
  .el-dialog__header {
    padding: 0;
  }
  .location-name{
    max-width: 90%;
    line-height: 20px;
  }
  .search-group {
    display: -webkit-box;
    margin-top: 20px;
    .el-input {
      display: block;
      max-width: 400px;
      width: 70%;
    }
    .search-btn-local {
      display: block;
      margin-left: 15px;
    }
  }
  .lng-lat-input{
      display: flex;
      align-items: center;
      margin-top: 20px;

      span{
        display: inline-block;
        width: 60px;
      }
  }
  .map-container{
      height: 400px;
      width: 100%;
      margin-top: 20px;
  }
}
.floor-btn-info{
      text-align: center;
      padding: 50px 0 20px;
      button{
          width: 180px;
          text-align: center;
          font-size: 16px;
          height: 45px;
          margin-right: 20px;
      }
  }
</style>
